<template>
    <div>
        <div class="table-header-bar">
            <!-- <div class="table-title">데이터 테이블</div> -->
            <!-- <button @click="clickCSV" class="export-btn">CSV 다운로드</button> -->
        </div>
        <div class="table-wrapper">
            <table class="table table-striped table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th class="bld-data-header-th">날짜</th>
                        <th v-for="(col, index) in data.thData" :key="index" class="bld-data-header-th">
                            {{ col.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rowIndex) in data.data" :key="rowIndex">
                        <td>{{ row.date }}</td>
                        <td v-for="(col, colIndex) in data.thData" :key="colIndex">
                            {{ row[col.key] ?? "-" }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        exportExcel: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        exportExcel(newVal) {
            if (newVal) {
                this.exportToExcel();
                this.$emit("update:exportExcel", false);
            }
        },
    },
    methods: {
        async exportToExcel() {
            try {
                if (!this.data || !Array.isArray(this.data.thData) || !Array.isArray(this.data.data)) {
                    console.warn("Excel 내보내기 실패: data 또는 thData/data가 유효하지 않음");
                    return;
                }

                // 헤더 정의
                const headers = ["날짜", ...this.data.thData.map((col) => col.label)];

                // 데이터 변환
                const excelData = this.data.data.map((row) => {
                    const rowData = {
                        날짜: row.date,
                    };

                    this.data.thData.forEach((col) => {
                        rowData[col.label] = row[col.key] !== null && row[col.key] !== undefined ? row[col.key] : "-";
                    });

                    return rowData;
                });

                // 컬럼 너비 설정
                const columnWidths = {
                    날짜: 20,
                };
                this.data.thData.forEach((col) => {
                    columnWidths[col.label] = 15;
                });

                // 셀 타입 설정
                const cellTypes = {
                    날짜: "string",
                };
                this.data.thData.forEach((col) => {
                    cellTypes[col.label] = "number";
                });

                const fileName = "에너지데이터.xlsx";
                const sheetName = "건물에너지데이터";

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName,
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths,
                    cellTypes,
                });

                // console.log("Excel 다운로드 완료:", fileName);
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
            }
        },
    },
};
</script>

<style scoped>
.table {
    width: 100%;
    margin-top: 10px;
    border-collapse: separate;
    border-spacing: 0;
}

.table th,
.table td {
    padding: 8px;
    text-align: center;
}

.table th {
    font-size: 13px;
}

/* 상단 바 스타일 */
.table-header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

/* 제목 (선택사항) */
.table-title {
    font-weight: 600;
    font-size: 16px;
}
.table-wrapper {
    max-height: 80vh;
    overflow-y: auto;
}
.table thead th {
    position: sticky;
    top: 0;
    background-color: #343a40;
    color: white;
    z-index: 1;
}
</style>
